import { Component, OnInit, Output,EventEmitter, ViewChild, Input, OnChanges } from '@angular/core';

import { BaseChartDirective} from "ng2-charts";
import { OptionOriginCode, OptionOriginCodeGraph } from '../option-origin-code.model';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { UserService } from 'app/Shared/Services/user.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { CommonModule } from '@angular/common';
import { ChartConfiguration} from 'chart.js';
@Component({
    selector: 'app-option-origin-code-graph',
    imports: [CommonModule, BaseChartDirective],
    templateUrl: './option-origin-code-graph.component.html',
    styleUrls: ['./option-origin-code-graph.component.scss']
})
export class OptionOriginCodeGraphComponent implements OnInit, OnChanges {
  isShow: boolean = false;
  @Output() closeDialog: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() selectedRow!: OptionOriginCode;
  @ViewChild(BaseChartDirective) chart!: BaseChartDirective;
  optionOriginCodeGraphData!: OptionOriginCodeGraph
  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    scaleShowValues: true,
    scaleValuePaddingX: 0,
    scaleValuePaddingY: 0,
    plugins: {
      colors: {
        enabled: true
      }
    },
    scales: {
      y: {
        //scaleLabel:{ display: true, labelString: 'Exception Count'},
        ticks: {
          beginAtZero: true,
          maxTicksLimit: 5,
          stepSize: 1,
          // Create Numberic notation labels
          callback: function (value: any, index: any, values: any) {

            if (value >= 1000 && value < 1000000) {
              value = value / 1000 + ' K';
            }
            if (value >= 1000000) {
              value = value / 1000000 + ' M';
            }
            return value;
          }
        }
      },
      x: {
        scrollbar: {
          enabled: true
        },
        ticks: {
          autoSkip: false
        }
      }
    },
    tooltips: {
      enabled: true,
      backgroundColor: 'Black',
      textColor: 'black',
      opacity: 1
    },
  };
  public barChartType: any = 'bar';
  public barChartLegend = true;
  public barChartData: any[] = [
    { data: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6], label: 'Order Count', backgroundColor: '#ee8336' },
    { data: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6], label: 'MTD Avg', backgroundColor: '#5b4a55'},
    { data: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6], label: '30 DMA', backgroundColor: '#95bfe4'}
  ];
  public chartColors: any[] = [
 
    { // red
      backgroundColor: '#ee8336',
      borderColor: '#ee8336',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
    { // dark grey
      backgroundColor: '#5b4a55',
      borderColor: '#5b4a55',
      pointBackgroundColor: 'rgba(77,83,96,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(77,83,96,1)'
    },
    { // grey
      backgroundColor: '#95bfe4',
      borderColor: '#95bfe4',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
  ];
  public barChartLabels: string[] = ['', '', '', '', '','','','','','','','','','','','','','','','','','','','','','','','','',''];
  
  public chartData: ChartConfiguration<'bar'>['data'] = {
    labels: this.barChartLabels,
    datasets: this.barChartData
  }
  
  constructor(private sharedHttpClientService: SharedHttpClientService,
    private userService: UserService,
    private urlsService: UrlsService) { }

  ngOnInit() {
    if(this.selectedRow.customerId) {
      this.getGraphData();
    }
  
  }
  ngOnChanges() {
    if(this.selectedRow && this.selectedRow.customerId) {
      this.getGraphData();
    }
  }

getGraphData() {
  this.sharedHttpClientService.post(
    this.urlsService.setAPIURl(
      APIURL.OptionOriginCode_GetGraph
    ), {
      mpid: this.selectedRow.firmMPID,
      reportDate: this.selectedRow.reportDate,
      customerId: this.selectedRow.customerId,
      days: "30"
      })
    .subscribe(data => {
      this.optionOriginCodeGraphData = data.response;
      this.barChartData[0].data = this.optionOriginCodeGraphData.sumOfOrderCount;
      this.barChartData[1].data = this.optionOriginCodeGraphData.sumOfMTDAvgCount;
      this.barChartData[2].data = this.optionOriginCodeGraphData.sumOfThirtyDayAvgCount;
      this.barChartLabels = this.optionOriginCodeGraphData.reportDate;
      this.barChartLabels.forEach((data, index) => {
        const formattedDate = this.userService.getMMMDDFormat(data);
        if(formattedDate !== null){
          this.barChartLabels[index] = formattedDate;
        } else {
          this.barChartLabels[index] = "";
        }
      })

      this.chartData = {
        labels: this.barChartLabels,
        datasets: this.barChartData
      }
    });
}

}
